// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const postApi = baseApi.injectEndpoints({
  reducerPath: "postApi",
  endpoints: (builder) => ({
    deleteComment: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/post-comments/post/${slug}`,
          method: "DELETE",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deletePost: builder.mutation({
      query: (slug) => {
        return {
          url: `post-delete/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["deletePost"],
    }),
    getPostDetailsWithComment: builder.query({
      query: (slug) => {
        return {
          url: `admin/post-comments/post/${slug}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getAllPosts: builder.query({
      query: ({ search, limit, page, event_id, group_id, visibility = 'public'}) => {
        let query = "admin/posts/?";
        if (visibility) query += "visibility=" + visibility;
        query += "&is_paginated=1&page=" + page + "&limit=" + limit;
        // if (user_id) query += "&user_id=" + user_id;
        if (search) query += "&query=" + search;
        if (group_id) query += "&group_id=" + group_id;
        if (event_id) query += "&event_id=" + event_id;

        return {
          url: query,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    postStatus: builder.mutation({
      query: (id) => {
        return {
          url: `admin/posts/status/${id}`,
          method: "PUT",
          // body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useDeleteCommentMutation,
  useDeletePostMutation,
  useGetPostDetailsWithCommentQuery,
  useGetAllPostsQuery,
  usePostStatusMutation,
} = postApi;
